import React from 'react';
import handleViewport from 'react-in-viewport';
import classNames from 'classnames';

const Module = props => {
  const { inViewport, leaveCount, enterCount, forwardedRef, className, type, ...otherProps } = props;

  return (
    <div
      className={classNames('module', props.className, `module--${type}`,{
        'module--visible': inViewport
      })}
      {...otherProps}
      ref={forwardedRef}
      >
      {props.children}
    </div>
  )
}

export default handleViewport(Module);
